import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PreviewBarLayout } from '~/components/organisms/previewBar/PreviewBarLayout';
import { PREVIEW_BAR_VIEW_TYPE } from '~/constants/common';
import { useAppDispatch } from '~/hooks/useRedux';
import { getQrCodeReducerData } from '~/store/reducers/qr-code/selectors';
import { stepperSlice } from '~/store/reducers/stepepr';
import useBuilderStore from '~/store/useBuilderStore';

import { PreviewScreen } from './components/utils/PreviewScreen';
import { resetAllMicrositesReducersToInitialState } from './utils';

const PreviewBar = ({ templateId }) => {
  const stepperActions = stepperSlice.actions;

  const dispatch = useAppDispatch();
  const qrCode = useSelector(getQrCodeReducerData);

  const { activeStep, setPreviewViewType } = useBuilderStore();

  useEffect(() => {
    if (!activeStep) {
      setPreviewViewType(PREVIEW_BAR_VIEW_TYPE.PHONE);
      dispatch(stepperActions.setIsMicrositeDataValid(true));

      resetAllMicrositesReducersToInitialState(dispatch);
    }

    if (activeStep === 2) {
      setPreviewViewType(PREVIEW_BAR_VIEW_TYPE.QRCODE);
    }
  }, [activeStep]);

  return (
    <PreviewBarLayout qrCodeData={qrCode?.data} isQrExist={Number(templateId) >= 0} isQrLoading={qrCode?.loading}>
      <PreviewScreen templateId={templateId} />
    </PreviewBarLayout>
  );
};

export default PreviewBar;
